import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { BsFillSearchHeartFill, BsMicFill } from "react-icons/bs";
import { BiCurrentLocation } from "react-icons/bi";
import { FiSearch } from "react-icons/fi";
import { BsChevronDown } from "react-icons/bs";
import { BsChevronUp } from "react-icons/bs";
import { Badge } from "react-bootstrap";
import { Baseurl } from "../../../config/BaseUrl";
import axios from "axios";
import { searchPost } from "../../../redux/search/SearchSlice";
import { getSubCategory } from "../../../redux/subCategory/SubCategorySlice";
import ReactSlider from "react-slider";

const PGCoLivingSearchComponent = (props) => {
  const { isAuth, loginData } = useSelector((store) => store.Athentication);
  const { subCatTotal } = useSelector((store) => store.SubCategory);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ref = useRef();

  const [showResults, setShowResults] = useState(false);
  const [toggle, setToggle] = useState(false);

  const [showSubcat, setShowSubcat] = useState([
    { name: "PG" },
    { name: "Co-Living" },
    { name: "Hostel" },
  ]);
  const [selectedSubcat, setSelectedSubcat] = useState([
    "PG",
    "Co-Living",
    "Hostel",
  ]);
  const [selectedBedrooms, setSelectedBedrooms] = useState([]);
  const [selectedPostedBy, setSelectedPostedBy] = useState([]);
  const [propertyPrice, setPropertyPrice] = useState([]);
  const [selectedSharing, setSelectedSharing] = useState([]);
  const [selectedAvailables, setSelectedAvailables] = useState([]);

  useEffect(() => {
    dispatch(getSubCategory());
  }, [dispatch]);

  useEffect(() => {
    props.getSubcatDetails(selectedSubcat);
    props.getBudgetDetails(propertyPrice);
    props.getBedRoomDetails(selectedBedrooms);
    props.getPostedDetailsDetails(selectedPostedBy);
    props.getSharingDetails(selectedSharing);
    props.getavailabilityDetails(selectedAvailables);
  }, [
    selectedSubcat,
    propertyPrice,
    selectedBedrooms,
    selectedPostedBy,
    selectedSharing,
    selectedAvailables,
  ]);

  useEffect(() => {
    if (subCatTotal && subCatTotal.length > 0) {
      const filterSubcat = subCatTotal.filter(
        (data) => data.superCategory === "Residential" && (data.category === "Rent" || data.category === "Pg")
      );
      if (filterSubcat.length > 0) {
        setShowSubcat(filterSubcat);
        setSelectedSubcat(filterSubcat.map((item) => item.name));
      }
    }
  }, [subCatTotal]);

  useEffect(() => {
    const clickoutside = (e) => {
      if (showResults && ref.current && !ref.current.contains(e.target)) {
        setShowResults(false);
      }
    };
    document.addEventListener("click", clickoutside);
    return () => {
      document.addEventListener("click", clickoutside);
    };
  }, [showResults]);

  useEffect(() => {
    setSelectedSubcat([...showSubcat.map((item) => item.name)]);
  }, [showSubcat]);
  
  const handleSubcatPress = (evt) => {
    if (selectedSubcat.includes(evt.target.value)) {
      setSelectedSubcat(
        selectedSubcat.filter((e) => {
          return e !== evt.target.value;
        })
      );
    } else {
      setSelectedSubcat((selectedSubcat) => [
        ...selectedSubcat,
        evt.target.value,
      ]);
    }
  };

  const handleavailablePress = (selectvalue) => {
    if (selectedAvailables.includes(selectvalue)) {
      setSelectedAvailables(
        selectedAvailables.filter((value) => value !== selectvalue)
      );
    } else {
      setSelectedAvailables([...selectedAvailables, selectvalue]);
    }
  };
  const handlesharingPress = (selectvalue) => {
    if (selectedSharing.includes(selectvalue)) {
      setSelectedSharing(
        selectedSharing.filter((value) => value !== selectvalue)
      );
    } else {
      setSelectedSharing([...selectedSharing, selectvalue]);
    }
  };
  const handlePostedByPress = (selectvalue) => {
    if (selectedPostedBy.includes(selectvalue)) {
      setSelectedPostedBy(
        selectedPostedBy.filter((value) => value !== selectvalue)
      );
    } else {
      setSelectedPostedBy([...selectedPostedBy, selectvalue]);
    }
  };

  const sharingStatus = [
    { id: "1", name: "Private Rooms" },
    { id: "2", name: "2 Per Room" },
    { id: "3", name: "3+ Per Room " },
  ];

  const availablesStatus = [
    { id: "1", name: "Girls" },
    { id: "2", name: "Boys" },
  ];
  const propertyPost = [
    { id: "1", name: "Owner" },
    { id: "2", name: "Builder" },
    { id: "3", name: "Dealer" },
  ];

  const handleClearAll = () => {
    setSelectedSubcat([]);
    setSelectedBedrooms([]);
    setSelectedPostedBy([]);
    setSelectedSharing([]);
    setSelectedAvailables([]);
    setPropertyPrice([]);
  };

  return (
    <>
      <div className="dropdownbox" style={{ paddingTop: "0" }}>
        <div className="clear-div">
          <p onClick={handleClearAll} role="button">
            Clear All
          </p>
        </div>
        <div className="showsubcatbanner">
          {showSubcat.map((subcat, index) => (
            <div className="subcatBoxbann" key={`pg-subcat-${index}`}>
              <div
                className={`childlabel ${
                  selectedSubcat.includes(subcat.name) ? "active-pill" : ""
                }`}
              >
                <input
                  type="checkbox"
                  id={`pg-subcat-${index}`}
                  name="pg-subcat"
                  value={subcat.name}
                  checked={selectedSubcat.includes(subcat.name)}
                  onChange={(e) => handleSubcatPress(e, subcat.name)}
                />
                <label htmlFor={`pg-subcat-${index}`}>
                  {subcat.name}
                </label>
              </div>
            </div>
          ))}
        </div>
        <div className="label-caption">
          <p>
            Looking for commercial properties ?<a href="#">Click here</a>
          </p>
          <hr />
        </div>

        <div className="dropdown-lists">
          <div className="parent-box">
            <div
              className={
                toggle === "Budget"
                  ? "main-boxes radioInput_textOnly__1r7GL radioInput_active__2BRQm active"
                  : "main-boxes radioInput_textOnly__1r7GL "
              }
              onClick={() => setToggle("Budget")}
            >
              <label className="">Budget</label>
              {toggle === "Budget" ? (
                <>
                  <BsChevronUp className="arrowicon" />
                </>
              ) : (
                <>
                  <BsChevronDown className="arrowicon" />
                </>
              )}
            </div>
            {toggle === "Budget" ? (
              <>
                <div className="range-box">
                  <div className="range-head">
                    <h6 className="">Select Price Range</h6>
                  </div>
                  <div className="range-bar">
                    <label htmlFor="customRange2" className="">
                      0 - 100 Crores+
                    </label>
                    <ReactSlider
                      className="horizontal-slider"
                      thumbClassName="example-thumb"
                      trackClassName="example-track"
                      defaultValue={[0, 1000000000]}
                      max={1000000000}
                      min={0}
                      renderThumb={(props, state) => (
                        <div {...props}>{state.valueNow}</div>
                      )}
                      onChange={(value, index) => setPropertyPrice(value)}
                    />
                  </div>
                </div>
              </>
            ) : (
              <>
                <div></div>
              </>
            )}
          </div>

          <div className="parent-box">
            <div
              className={
                toggle === "Sharing"
                  ? "main-boxes radioInput_textOnly__1r7GL radioInput_active__2BRQm active"
                  : "main-boxes radioInput_textOnly__1r7GL "
              }
              onClick={() => setToggle("Sharing")}
            >
              <label className="">Sharing </label>
              {toggle === "Sharing" ? (
                <>
                  <BsChevronUp className="arrowicon" />
                </>
              ) : (
                <>
                  <BsChevronDown className="arrowicon" />
                </>
              )}
            </div>
            {toggle === "Sharing" ? (
              <>
                <div className="bedroombox mediabedroom">
                  <div className="bedroom-head">
                    <h6 className="">Sharing</h6>
                  </div>
                  <div className="boxes-parent" style={{ marginTop: "-2px" }}>
                    {sharingStatus.map((data, index) => (
                      <div
                        key={index}
                        className={
                          selectedSharing.includes(data.id)
                            ? "  tags-and-chips_textOnly__2k10B pageComponent tags-and-chips_active__37Gi0 "
                            : "  tags-and-chips_textOnly__2k10B pageComponent "
                        }
                        onClick={() => {
                          handlesharingPress(data.id);
                        }}
                      >
                        <label className="">{data.name}</label>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div></div>
              </>
            )}
          </div>

          <div className="parent-box">
            <div
              className={
                toggle === "Posted"
                  ? "main-boxes radioInput_textOnly__1r7GL radioInput_active__2BRQm active"
                  : "main-boxes radioInput_textOnly__1r7GL "
              }
              onClick={() => setToggle("Posted")}
            >
              <label className="">Posted By</label>
              {toggle === "Posted" ? (
                <>
                  <BsChevronUp className="arrowicon" />
                </>
              ) : (
                <>
                  <BsChevronDown className="arrowicon" />
                </>
              )}
            </div>
            {toggle === "Posted" ? (
              <>
                <div className="bedroombox">
                  <div className="posted-head">
                    <h6 className="">Posted By</h6>
                  </div>
                  <div className="posted-main" style={{ marginTop: "-2px" }}>
                    {propertyPost.map((data, index) => (
                      <div
                        className={
                          selectedPostedBy.includes(data.name)
                            ? "  tags-and-chips_textOnly__2k10B pageComponent tags-and-chips_active__37Gi0 "
                            : "  tags-and-chips_textOnly__2k10B pageComponent "
                        }
                        onClick={() => {
                          handlePostedByPress(data.name);
                        }}
                      >
                        <label className="">{data.name}</label>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div></div>
              </>
            )}
          </div>

          <div className="parent-box">
            <div
              className={
                toggle === "Available"
                  ? "main-boxes radioInput_textOnly__1r7GL radioInput_active__2BRQm active"
                  : "main-boxes radioInput_textOnly__1r7GL "
              }
              onClick={() => setToggle("Available")}
            >
              <label className="">Available For</label>
              {toggle === "Available" ? (
                <>
                  <BsChevronUp className="arrowicon" />
                </>
              ) : (
                <>
                  <BsChevronDown className="arrowicon" />
                </>
              )}
            </div>
            {toggle === "Available" ? (
              <>
                <div className="bedroombox">
                  <div className="construction-head">
                    <h6 className="">Available For</h6>
                  </div>
                  <div
                    className="construction-boxes"
                    style={{ marginTop: "-2px" }}
                  >
                    {availablesStatus.map((data, index) => (
                      <div
                        key={index}
                        className={
                          selectedAvailables.includes(data.name)
                            ? "  tags-and-chips_textOnly__2k10B pageComponent tags-and-chips_active__37Gi0 "
                            : "  tags-and-chips_textOnly__2k10B pageComponent "
                        }
                        onClick={() => {
                          handleavailablePress(data.name);
                        }}
                      >
                        <label className="">{data.name}</label>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div></div>
              </>
            )}
          </div>

          <div className=""></div>
        </div>
      </div>
    </>
  );
};

export default PGCoLivingSearchComponent;
